import { CodeBracketSquareIcon, VariableXIcon, VariableYIcon } from "@components/library/Icons";
import { ExclamationIcon, FlagIcon } from "@heroicons/react/outline";

export const InputName = ({ name, hideIcon }: { name: string; hideIcon?: boolean }) => (
  <div className="flex items-center gap-6 truncate" title={name}>
    {!hideIcon && <VariableXIcon className="-my-1 h-20 w-20 flex-none text-oldgray-700" />}
    <div className="truncate text-13-18 text-oldgray-700">{name}</div>
  </div>
);

export const ToolName = ({ name }: { name: string }) => (
  <div className="flex items-center gap-6 truncate" title={name}>
    <CodeBracketSquareIcon className="h-20 w-20 flex-none text-oldgray-700" />
    <div className="truncate text-13-18 text-oldgray-700">{name}</div>
  </div>
);

export const OutputName = ({}: {}) => (
  <div className="flex items-center gap-6 truncate">
    <VariableYIcon className="-my-1 h-20 w-20 flex-none text-oldgray-700" />
    <div className="truncate text-13-18 text-oldgray-700">Output</div>
  </div>
);

export const ErrorName = () => (
  <div className="flex items-center gap-6 truncate font-sans text-text-danger-2">
    <ExclamationIcon className="h-16 w-16 text-icon-danger-2" /> Error
  </div>
);
